/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge20 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])

	const fill: any = props.item.fill || "var(--force-contast-color)" 

	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<path fill={fill}  d="M243.9,37.4c-0.9-0.4-1.1,0.6-1.6,0.9c-0.6,0.4-1.1,0.8-1.8,0.4c-0.5-0.3-0.7-0.9-0.6-1.5c0.1-1.5,0.3-3,0.4-4.5
				c0.1-0.6,0.3-1.1,0.4-1.7c0.2-0.9-0.1-1.5-1-1.9c-1.7-0.7-3.6-1.1-5-2.7c0.9-1.3,2.2-1.4,3.5-1.6c1.5-0.2,3.1-0.4,4.6-0.7
				c0.5-1.5,0.9-3,1.4-4.6c0.3-0.9,0.5-1.8,0.9-2.6c0.5-1,1.5-1.1,2.2-0.4c0.4,0.4,0.8,0.8,1,1.3c0.3,0.6,0.7,1.2,0.9,1.8
				c0.5,1.7,1.8,2.2,3.3,2.2c1.2,0,2.4,0,3.7,0.1c0.8,0.1,1.1,0.9,0.5,1.5c-1.2,1.4-2.4,2.7-3.7,4c-0.6,0.7-0.7,1.4-0.1,2.1
				c1.1,1.4,2.2,2.9,3.3,4.3c0.4,0.6,0.7,1.2,0.4,1.9c-0.4,1.1-1.3,1.5-2.4,1.1c-1.3-0.5-2.4-1.2-3.5-2c-0.9-0.7-1.8-1.3-2.7-2
				c-0.4-0.3-0.8-0.3-1.2,0c-1.1,1.1-2.3,2.1-3.1,3.6C243.8,36.8,243.9,37.1,243.9,37.4L243.9,37.4z M251.9,33.7c0.4,0.3,0.8,0.7,1.2,1
				c0.1,0.1,0.4,0.1,0.6,0c0.5-0.3,0-0.5-0.1-0.7c-0.2-0.3-0.6-0.6-0.9-0.9c-0.1-0.2-0.2-0.4-0.3-0.6c-2.2-4.9-2.6-3.7,1.2-7.4
				c0.1-0.1,0-0.2,0-0.5c-1,0-1.9-0.1-2.9,0c-1.6,0.2-2.5-0.6-3-2.1c-0.4-1.1-0.8-2.1-1.3-3.3c-1.4,1.4-1.8,3.3-2.3,5
				c-0.5,1.6-1.4,2.2-2.9,2.3c-1,0-2.1-0.2-3.6,0.5c1.5,0.5,2.6,0.8,3.6,1.2c1,0.3,1.4,1,1.4,2.1c0,0.5-0.1,0.9,0,1.4
				c0,0.4-0.3,0.9,0.5,1.1c0.5-0.5,1.1-1,1.7-1.5c1.2-0.9,1.5-0.8,2.9,0.2C249.2,32.1,250.5,32.8,251.9,33.7z"/>
			<path fill={fill}  d="M112.6,27.4c-2.1,0-4.2,0.1-6.3,0c-1.6-0.1-2.9,0-4.1,1.6c-1.1,1.4-2.8,1.7-4.6,1c-2.2-0.8-3.3-3-2.6-5.2
				c0.6-1.8,2.9-3.1,4.9-2.6c1.3,0.3,2.3,1,2.9,2.2c0.5,1.2,1.2,1.4,2.4,1.3c4.6-0.6,9.3-0.4,14-0.5c0.7,0,1.3,0,2,0
				c0.4,0,0.9,0.1,1,0.7c0,0.7-0.1,1.5-0.9,1.6c-0.8,0.2-1.5,0.1-2.3,0.1c-2.1,0-4.2,0-6.3,0C112.6,27.5,112.6,27.5,112.6,27.4z"/>
			<path  fill={fill} d="M389.8,25.2c1.4,0,2.9-0.1,4.3,0c1.2,0.1,2.1-0.1,2.6-1.5c0.5-1.5,1.9-2.1,3.3-2.6c1.2-0.4,2.2,0,3.1,0.8
				c0.9,0.9,1.6,1.9,2,3.1c0.4,1.5,0.1,3-1,4.1c-1.1,1.2-2.4,1.6-3.9,1.2c-1.2-0.3-2.4-0.8-3.1-1.9c-0.8-1.2-1.8-1.5-3.1-1.5
				c-2.9,0-5.8-0.1-8.6-0.2c-0.7,0-1.6,0.3-1.9-0.8c-0.2-0.7,0.6-1.2,2-1.1c1.4,0.1,2.9,0.2,4.3,0.2C389.8,25.1,389.8,25.2,389.8,25.2z
				"/>
			<path fill={fill}  d="M349.4,27.9c-2.1,0-4.2,0-6.3,0c-1.7,0-1.9-0.3-1.9-1.6c0-1.4,0.2-1.7,1.8-1.7c3.2,0,6.4,0,9.6,0c1.3,0,2.7-0.1,4-0.1
				c0.9,0,1.1,0.6,1.1,1.4c0,0.8,0.1,1.8-1,1.8C354.3,27.9,351.9,27.8,349.4,27.9C349.4,27.9,349.4,27.9,349.4,27.9z"/>
			<path fill={fill}  d="M199.6,27.1c-0.6-0.7-0.6-1.2-0.6-1.8c0-1,0.3-1.5,1.3-1.5c5-0.1,10,0.2,14.9,0.5c0.7,0,1,0.4,0.9,1.1
				c-0.1,0.4-0.2,0.9-0.8,0.9C210,26.3,204.7,26.6,199.6,27.1z"/>
			<path fill={fill}  d="M160.5,27.4c-2.2,0-4.4,0-6.6,0c-1.1,0-1.8-1.4-1.3-2.5c0.3-0.6,0.9-0.5,1.5-0.5c3.2-0.1,6.4-0.1,9.6-0.2c1.2,0,2.4,0,3.7,0
				c1.5,0,1.7,0.3,1.7,1.4c0,1.4-0.3,1.7-1.9,1.7C164.9,27.3,162.7,27.3,160.5,27.4C160.5,27.3,160.5,27.4,160.5,27.4z"/>
			<path fill={fill}  d="M137.2,27.6c-2.1,0-4.2,0-6.3,0c-0.8,0-1.2-0.4-1.2-1.3c0-0.8,0.2-1.3,1.1-1.4c4.3-0.1,8.6-0.2,12.9-0.2
				c0.8,0,1.2,0.3,1.3,1.2c0,1.1-0.2,1.6-1.2,1.6C141.6,27.6,139.4,27.5,137.2,27.6C137.2,27.6,137.2,27.6,137.2,27.6z"/>
			<path fill={fill}  d="M183.8,27.7c-2,0-4,0-6,0c-1.1,0-1.3-0.4-1.3-1.9c0-1.1,0.2-1.4,1.4-1.4c4.1,0,8.2,0,12.3-0.1c0.8,0,1.2,0.4,1.1,1.3
				c0,0.8,0.1,1.8-0.9,1.9c-2.2,0.1-4.4,0-6.6,0C183.8,27.6,183.8,27.6,183.8,27.7z"/>
			<path fill={fill}  d="M326.8,27.8c-1.7,0-3.3,0-5,0c-1,0-1.4-0.5-1.4-1.5c0-1.1,0.2-1.6,1.2-1.6c3.6-0.1,7.3-0.2,10.9-0.2c0.9,0,1.2,0.4,1.2,1.6
				c0,1.2-0.2,1.5-1.3,1.6C330.6,27.7,328.7,27.7,326.8,27.8C326.8,27.7,326.8,27.8,326.8,27.8z"/>
			<path fill={fill}  d="M285.7,27.8c-2,0-4,0-6,0c-0.7,0-1-0.4-1-1.1c0-0.6,0.2-1.2,0.9-1.2c1.9-0.1,3.8-0.1,5.7-0.1c2.2,0,4.4-0.1,6.7-0.1
				c0.9,0,1.1,0.6,1.2,1.3c0.1,0.6-0.1,1.2-0.8,1.2C290.1,27.9,287.9,27.8,285.7,27.8z"/>
			<path fill={fill}  d="M370.9,24.4c1.3,0,2.7,0,4,0c0.6,0,1.1,0.3,1.1,1c0,0.8-0.2,1.3-1.1,1.5c-0.3,0-0.7,0.1-1,0.1c-2.3,0.1-4.6,0.3-7,0.4
				c-1.6,0.1-1.9-0.4-1.7-2c0.1-0.7,0.4-1,1.1-1C367.8,24.3,369.4,24.3,370.9,24.4C370.9,24.3,370.9,24.3,370.9,24.4z"/>
			<path fill={fill}  d="M301.1,27.8c-0.1-0.6-0.2-1-0.3-1.5c-0.1-0.6,0.1-1.1,0.8-1.2c3.5,0,6.9-0.1,10.4-0.1c0.9,0,0.9,0.8,0.9,1.5
				c0,0.6-0.1,1.2-0.9,1.2C308.4,27.8,304.8,27.8,301.1,27.8z"/>
			<path fill={fill}  d="M98.3,35.2c1.3,0.1,2.4,1.4,2.3,2.8c-0.1,1.5-1.7,3-3.2,2.9c-1.2-0.1-2.1-1.2-2-2.6C95.5,36.5,96.8,35.1,98.3,35.2z"/>
			<path fill={fill}  d="M231,34c-1.4,0-2.8-1.3-2.8-2.8c0-1.5,1.4-2.8,2.8-2.8c1.3,0,2.5,1.2,2.6,2.6C233.7,32.6,232.4,34,231,34z"/>
			<path fill={fill}  d="M256.5,12.4c1,0,2.1,1,2.2,2.1c0.1,1.3-1.5,2.8-2.8,2.8c-1.1-0.1-2.1-1.2-2-2.3C254,13.6,255.2,12.4,256.5,12.4z"/>
			<path fill={fill}  d="M403.2,38.4c-0.1,1.3-1.4,2.5-2.8,2.4c-1.2,0-1.9-1-1.8-2.4c0.1-1.6,1.2-2.6,2.6-2.4C402.4,36.2,403.3,37.3,403.2,38.4z"/>
			<path fill={fill}  d="M262.6,26.9c1-0.6,2-0.4,3-0.5c1.7-0.2,3.3-0.3,5-0.4c0.3,0,0.6,0.2,0.7,0.6c0.1,0.5-0.2,0.9-0.6,1
				C269.3,27.9,264.5,27.5,262.6,26.9z"/>
			<path fill={fill}  d="M234.9,40.8c0,1.1-0.8,2-1.8,2.1c-1.1,0.1-2.1-0.9-2.1-2.1c0-1,0.8-2,1.8-2C234,38.7,234.9,39.6,234.9,40.8z"/>
			<path fill={fill}  d="M110.2,17.6c0,1.2-0.9,2.1-2.1,2.1c-1.1,0-1.9-0.9-1.9-1.9c0.1-1,1.2-2.1,2.2-2.2C109.3,15.5,110.2,16.6,110.2,17.6z"/>
			<path fill={fill}  d="M250.1,43.9c-1.1,0-1.9-0.8-2-1.9c0-1.1,0.8-2,1.9-2c1,0,2,0.9,2,1.9C252.1,43,251.2,43.9,250.1,43.9z"/>
			<path fill={fill}  d="M406.7,20.2c0-0.9,1.4-2.1,2.6-2.1c0.7,0,1.4,0.7,1.4,1.6c0,1.2-1.1,2.2-2.4,2.3C407.6,22,406.8,21.1,406.7,20.2z"/>
			<path fill={fill}  d="M391.1,31.8c0.9,0,1.5,0.7,1.5,1.8c0,1-0.6,1.7-1.5,1.7c-0.8,0-1.5-0.7-1.6-1.4C389.4,32.9,390.2,31.8,391.1,31.8z"/>
			<path fill={fill}  d="M239.6,19.6c0,0.8-0.6,1.5-1.5,1.5c-0.8,0-1.5-0.6-1.5-1.4c-0.1-1,0.7-1.8,1.6-1.7C239,18.1,239.6,18.8,239.6,19.6z"/>
			<path fill={fill}  d="M227,24.9c1.1,0.2,2.2-0.2,3.3,0.3c0.2,0.1,0.2,0.3,0.3,0.5c0.1,0.3,0,0.5-0.3,0.5c-2,0.5-4,0.2-5.9,0
				c-0.4,0-0.4-0.5-0.3-0.8c0-0.2,0.2-0.4,0.3-0.5C225.2,24.5,226.1,25,227,24.9z"/>
			<path fill={fill}  d="M91.8,30c-0.1,0.1-0.1,0.4-0.3,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-1.4,0-2.1-0.5-2.3-1.4c-0.1-0.4,0.1-0.7,0.4-0.8
				c1-0.6,1.6,0.3,2.3,0.7C91.6,29.4,91.8,29.6,91.8,30z"/>
			<path fill={fill}  d="M260.8,31.4c0.8-0.1,1.5,0.5,1.5,1.3c0,0.6-0.3,1.1-0.9,1.2c-0.6,0.1-1.4-0.7-1.3-1.5C260.1,31.9,260.3,31.5,260.8,31.4z"/>
			<path fill={fill}  d="M261.8,40.9c-0.2,0.5-0.3,1-0.9,1c-0.5-0.1-0.7-0.5-0.6-1c0.1-0.5,0.4-0.9,0.9-0.9C261.7,40.1,261.9,40.5,261.8,40.9z"/>
			<path fill={fill}  d="M394.1,15.2c0,0.6-0.3,0.8-0.8,0.8c-0.7,0-0.9-0.5-0.9-1.1c0-0.4,0.3-0.9,0.8-0.8C393.7,14.2,394,14.7,394.1,15.2z"/>
			<path fill={fill}  d="M95.1,14.5c0.6,0.2,0.7,0.7,0.9,1.2c0,0-0.3,0.3-0.5,0.3c-0.7,0-0.9-0.5-0.8-1.1C94.7,14.8,95,14.6,95.1,14.5z"/>
			<path fill={fill}  d="M245,7.9c0.5,0,0.8,0.3,0.8,0.8c0,0.1-0.3,0.3-0.4,0.4c-0.5,0.1-0.8-0.2-0.8-0.8C244.5,8.2,244.8,8,245,7.9z"/>
			<path fill={fill}  d="M410.6,29.8c0.5,0,0.7,0.3,0.8,0.8c0,0.4-0.2,0.6-0.5,0.6c-0.5,0-0.7-0.3-0.8-0.8C410.1,30.1,410.3,29.9,410.6,29.8z"/>
			<path fill={fill}  d="M106.9,32c0.4,0,0.8,0.2,0.8,0.7c0,0.4-0.3,0.6-0.6,0.6c-0.5,0-0.8-0.2-0.8-0.7C106.2,32.2,106.5,32.1,106.9,32z"/>
			<path fill={"#FF779F"} d="M251.9,33.7c-1.3-0.8-2.7-1.6-4-2.5c-1.4-1-1.7-1.1-2.9-0.2c-0.6,0.5-1.2,1-1.7,1.5c-0.8-0.1-0.5-0.7-0.5-1.1
				c-0.1-0.5,0-0.9,0-1.4c0-1.1-0.5-1.7-1.4-2.1c-1-0.4-2.1-0.7-3.6-1.2c1.5-0.7,2.6-0.4,3.6-0.5c1.5,0,2.4-0.6,2.9-2.3
				c0.5-1.7,0.9-3.5,2.3-5c0.5,1.2,0.9,2.2,1.3,3.3c0.5,1.5,1.4,2.3,3,2.1c1-0.1,1.9,0,2.9,0c0,0.3,0,0.4,0,0.5
				c-3.8,3.7-3.4,2.5-1.2,7.4c0.1,0.2,0.2,0.4,0.3,0.6C252.4,33.2,252.2,33.4,251.9,33.7z"/>
			<path fill={fill}  d="M252.7,33c0.3,0.3,0.6,0.6,0.9,0.9c0.1,0.2,0.6,0.5,0.1,0.7c-0.1,0.1-0.4,0.1-0.6,0c-0.4-0.3-0.8-0.6-1.2-1
				C252.2,33.4,252.4,33.2,252.7,33z"/>
		</svg>
	</div>
}

